import { cmpCookie } from "@foundation/cmp-client";
import UserInfo from "../session/UserInfo";
import { makeCachedGet } from "../util/requestHelpers";
import { Targeting, TargetingProvider } from "../interfaces/TargetingProvider";
import AdsServiceClient from "./AdsServiceClient";

export enum UserGlobalTargetingType {
    PERSONALIZATION = "personalization",
    DV = "dv",
    TRIGR = "tr"
}
const storageKey = "bbads_targetings";

export class UserGlobalTargetingProvider implements TargetingProvider {

    private targetingUrl = `${ process.env.ADS_SERVICE_ENDPOINT }/ad-targeting/user-global`;
    private get: ReturnType<typeof makeCachedGet<Targeting>>;
    private timeoutInMs: number;
    private types: UserGlobalTargetingType[];
    private _userInfo: UserInfo;

    constructor(
        targetingTypes: UserGlobalTargetingType[],
        userInfo: UserInfo,
        timeout:number = 5000
    ) {
        this.types = targetingTypes;
        this.get = makeCachedGet<Targeting>("UserGlobalTargeting");
        this._userInfo = userInfo;
        this.timeoutInMs = timeout;
    }

    private async buildUrl(): Promise<string> {
        // need to send user consent to AdService to determine whether to call
        // coordinator for user information
        const padAllowed = cmpCookie.padAllowed() ? "true" : "false";
        // need slot id and ad unit path to target away from IVT
        const ad = await AdsServiceClient.waitForFirstAd();
        const sessionId = await this._userInfo.getSessionId().catch((error) => console.error("Failed to get session ID:", error));
        const adCode = `&ad_code=${ encodeURIComponent(ad.getUnitName()) }`;
        const slotId = `&slot_id=${ ad.getId() }`;
        const url = `${ this.targetingUrl }?targeting_types=${ this.types }${ sessionId ? `&session_id=${ sessionId }` : "" }&consent=${ padAllowed }${ adCode }${ slotId }`;

        return url;
    }

    async getTargeting(): Promise<Targeting> {
        return this.get(await this.buildUrl(), this.timeoutInMs, {}, storageKey);
    }

}
